'use client';
import { isString, isNumber } from '@s7/utils';
import { createCache } from '../cache/createCache/createCache.js';

var serialize = function(data) {
    return isString(data) ? data : isNumber(data) ? String(data) : JSON.stringify(data);
};
var deserialize = function(data) {
    try {
        return JSON.parse(data);
    } catch (e) {
        return data;
    }
};
/**
 * SSR-безопасный провайдер кэша.
 * В качестве слоя персистентности использует sessionStorage.
 * */ var SessionStorageCache = createCache(function() {
    var storage = window.sessionStorage;
    var setItem = storage.setItem, getItem = storage.getItem;
    return {
        persist: function(ident, data) {
            setItem.call(storage, ident.toString(), serialize(data));
        },
        restore: function(ident) {
            var data = getItem.call(storage, ident.toString());
            if (data) {
                return deserialize(data);
            }
            return null;
        }
    };
}, true);

export { SessionStorageCache };
